import {SharedValueKey} from '@epic-core/hooks';

export interface SharedKeys {
    [key: string]: SharedValueKey<any>;
}

export const AppSharedKeys: SharedKeys = {
    CmsStore: {id: 'CmsStore', defaultValue: {}},
    CmsTreeStore: {id: 'CmsTreeStore', defaultValue: {}},
    AccountStore: {id: 'AccountStore', defaultValue: {}},
    HeaderStore: {id: 'HeaderStore', defaultValue: {}},
    FooterStore: {id: 'FooterStore', defaultValue: {}},
    MiscStore: {id: 'MiscStore', defaultValue: {}},
    EulaStore: {
        id: 'EulaStore',
        defaultValue: {
            ue_games: {},
            ue_non_games: {},
            twin: {}
        }
    },
    FeaturesStore: {id: 'FeaturesStore', defaultValue: {}},
    FeedItemsStore: {
        id: 'FeedItemsStore',
        defaultValue: {
            items: [],
            latestStores: [],
            tags: {}
        }
    },
    FeedItemsLatestStore: {
        id: 'FeedItemsLatestStore',
        defaultValue: {
            items: [],
            patternsToSkip: []
        }
    },
    FeedStore: {id: 'FeedStore', defaultValue: {}},
    AcademicPartnersStore: {id: 'AcademicPartnersStore', defaultValue: {}},
    ReleaseStore: {id: 'ReleaseStore', defaultValue: {}},
    SearchStore: {id: 'SearchStore', defaultValue: {}},
    JobsStore: {id: 'JobsStore', defaultValue: {}},
    LaunchDarklyStore: {id: 'LaunchDarklyStore', defaultValue: {}}
};
